export default __webpack_public_path__ + "static/media/logo-a2015.065e093b.png";